import React from 'react';
import './HeroSection.css'; // Add a CSS file for styles
import Carousel from './Carousel';
const HeroSection = () => {
  return (
     
    <section id="home">
    <Carousel />

  </section>
    
  );
};

export default HeroSection;
